import { checkClass } from "../../../tools/checkClass";
import OnlineIcon from "../../../../assets/imgs/online.gif";
import OfflineIcon from "../../../../assets/imgs/offline.gif";
import { useNavigate } from "react-router-dom";
import { useLang } from "../../../../i18n/LangContext";

const Pages = ({ numberPages, OriginPages, newPages }) => {
  const navigate = useNavigate();
  const { t } = useLang();

  const head = (
    <tr>
      <th>#</th>
      <th>{t("col_name")}</th>
      <th>{t("col_level")}</th>
      <th>{t("col_reset")}</th>
      <th>{t("col_status")}</th>
    </tr>
  );

  const row = (player, i) => (
    <tr
      style={{ cursor: "pointer" }}
      onClick={() => navigate(`/player/${player.Name}`)}
      key={i}
    >
      <td>{i + 1}</td>
      <td>
        <span className="PlayerNameTop100">
          <img className="imgClass" src={checkClass(player.Class)} alt="" />
          {player.Name}
        </span>
      </td>
      <td>{player.cLevel}</td>
      <td>{player.Reset}</td>
      <td>
        {player.userOnline == 1 ? (
          <img src={OnlineIcon} alt="" />
        ) : (
          <img src={OfflineIcon} alt="" />
        )}
      </td>
    </tr>
  );

  if (OriginPages) {
    return (
      <table className="Top10Players">
        <thead>{head}</thead>
        <tbody>{OriginPages.map((player, i) => row(player, i))}</tbody>
      </table>
    );
  }

  if (numberPages == 0) {
    return (
      <table className="Top10Players">
        <thead>{head}</thead>
        <tbody>{newPages?.[0]?.map((player, i) => row(player, i))}</tbody>
      </table>
    );
  }

  if (numberPages == 1) {
    return (
      <table className="Top10Players">
        <thead>{head}</thead>
        <tbody>{newPages?.[1]?.map((player, i) => row(player, i))}</tbody>
      </table>
    );
  }

  if (numberPages == 2) {
    return (
      <table className="Top10Players">
        <thead>{head}</thead>
        <tbody>{newPages?.[2]?.map((player, i) => row(player, i))}</tbody>
      </table>
    );
  }

  return null;
};

export default Pages;
